module.exports = __webpack_public_path__ + "assets/img/steam.3d634472.png";